/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import React, {Component} from 'react';
import {connect} from 'react-redux';
import {clearRecentAssetsCache} from 'recent-assets';
import {deleteCookie} from '../../../utils/cookie';
import RedirectionUtils from '../../../utils/RedirectionUtils';
import ProfileStorage from '../../personalization/ProfileStorage';

interface Props {
	app: app;
	signedIn: boolean;
	isUserEntitled: boolean;
	history: { goBack: Function; push: Function; replace: Function };
}

export default (ChildComponent) => {
	class RequireAuth extends Component<Props> {
		render() {
			switch (this.props.signedIn) {
				case false:
					// Clear any cached profile information for this user.
					ProfileStorage.removeProfilesResponseFromSessionStorage();
					clearRecentAssetsCache();
					deleteCookie('cchome-logggedIn');
					RedirectionUtils.redirectLoggedOut(this.props.app.language);
					// falls through
				case null:
					return <div className='loading' />;

				default:
					if (this.props.isUserEntitled) {
						// Remove the cosntext param from the URL if present.
						if (RedirectionUtils.hasContextQueryParam(window.location.href)) {
							this.props.history.replace(
								RedirectionUtils.returnPathWithoutContextParam(window.location.href),
							);
						}
						RedirectionUtils.redirectLoggedIn();
						return <ChildComponent {...this.props} />;
					} // The user is not eligible, redirect them to the appropriate localized pages on Adobe.com

					setTimeout(() => {
						window.location.assign(
							RedirectionUtils.getAdobeRedirectURL(window.location.href, this.props.app.language),
						);
					}, 1000);
					return '';
			}
		}
	}

	function mapStateToProps({auth}) {
		return {
			signedIn: auth.signedIn,
			isUserEntitled: auth.isUserEntitled,
		};
	}

	return connect(mapStateToProps, {})(RequireAuth);
};
/* eslint-enable no-unused-vars */
